// removed by extract-text-webpack-plugin
module.exports = {"radar":"radar___1B7C0","legend":"legend___E-jrL","legendItem":"legendItem___7yzou","split":"split___E6MMV","dot":"dot___1rECQ"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/Radar/index.less
// module id = 427
// module chunks = 0 1